import { isEmpty } from 'lodash';
import { TOOL_CALL_STATUS } from '@kentik/ui-shared/kaizen/constants';

const TOOLS_REQUIRING_RAW_RESULT = new Set(['device_connections']);

// Statuses where the tool never ran, so its proposed input is still what the user should see.
const APPROVAL_PREVIEW_STATUSES = new Set([
  TOOL_CALL_STATUS.AWAITING_APPROVAL,
  TOOL_CALL_STATUS.USER_REJECTED,
  TOOL_CALL_STATUS.APPROVAL_TIMEOUT
]);

export const hasToolResultData = (tool) => !TOOLS_REQUIRING_RAW_RESULT.has(tool.tool_name) || !isEmpty(tool.raw_result);

export const isShowingApprovalPreview = (tool) =>
  !!tool.query_object?._hasApprovalPreview && (APPROVAL_PREVIEW_STATUSES.has(tool.status) || !!tool.awaitingApproval);
